import React from 'react';

import { Table } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { columns } from './datasource';

function GSVSTable({
  items,
  current,
  pageSize,
  loading,
  onRowClick,
  total,
  onChange,
}) {
  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        showSizeChanger: true,
        pageSize,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
        total,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { GSVSTable };
